import React from 'react';
import { ProjectStatus } from '../../types';
import { useI18n } from '../../context/I18nContext';
import Badge from '../ui/Badge';

/** Clés i18n statut projet — source unique pour badges / listes. */
export const PROJECT_STATUS_I18N_KEYS: Record<ProjectStatus, string> = {
  BRIEF_RECEIVED: 'projects.statusBriefReceived',
  IN_PRODUCTION: 'projects.statusInProduction',
  V1_SENT: 'projects.statusFirstVersion',
  CHANGES_REQUESTED: 'projects.statusCorrections',
  DELIVERED: 'projects.statusDelivered',
  ARCHIVED: 'projects.statusArchived',
};

/** Badge variant par statut projet (aligné Kanban / RecentProjects). */
export const PROJECT_STATUS_BADGE_VARIANT: Record<
  ProjectStatus,
  React.ComponentProps<typeof Badge>['variant']
> = {
  BRIEF_RECEIVED: 'blue-pastel',
  IN_PRODUCTION: 'violet-pastel',
  V1_SENT: 'yellow-pastel',
  CHANGES_REQUESTED: 'orange-pastel',
  DELIVERED: 'green-dark-pastel',
  ARCHIVED: 'default',
};

interface ProjectStatusBadgeProps {
  status: ProjectStatus | string;
  size?: 'sm' | 'md';
  className?: string;
}

const ProjectStatusBadge: React.FC<ProjectStatusBadgeProps> = ({
  status,
  size = 'sm',
  className = 'max-w-full truncate',
}) => {
  const { t } = useI18n();
  const key = status as ProjectStatus;
  const variant = PROJECT_STATUS_BADGE_VARIANT[key] || 'default';
  const label = t(PROJECT_STATUS_I18N_KEYS[key] || 'status.unknown');

  return (
    <Badge variant={variant} size={size} className={className}>
      {label}
    </Badge>
  );
};

export default ProjectStatusBadge;
